// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ColumnOrderingItem-item__SB_Mk{min-height:var(--size-10);padding:var(--size-0) var(--size-3)}.ColumnOrderingItem-actions__Tg6Rj{display:flex;gap:var(--size-2);align-items:center}.ColumnOrderingItem-dragging__UpSt5{z-index:var(--z-index-dragging-card)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "ColumnOrderingItem-item__SB_Mk",
	"actions": "ColumnOrderingItem-actions__Tg6Rj",
	"dragging": "ColumnOrderingItem-dragging__UpSt5"
};
export default ___CSS_LOADER_EXPORT___;
